module.exports = __webpack_public_path__ + "img/epr@2x.c7c04e48.webp";